// extracted by mini-css-extract-plugin
export default {"miniContainer":"GeneralInfo_miniContainer__TXFP4","container":"GeneralInfo_container__DxcAq"};